

var SearchService =  (function() {
    
    var searchServiceBaseUrl;
    
    //Private Methods
    var simpleAjaxRequest = function (method, argument) {
        ajaxRequest(method, argument, null, null);
    }
    var ajaxRequest = function (method, args, successCallback, errorCallback) {
        $.ajax({
            url: searchServiceBaseUrl,
            type: 'POST',
            cache: false,
            data: { method: method, args: args },
            success: successCallback,
            error: errorCallback
        });
    }

    return {
        Init: function(url) {
            searchServiceBaseUrl = url
        },

        SetCoverVisibility: function(visible) {
            simpleAjaxRequest('SetCoverVisibility', { visible: visible } );
        },

        SetSearchDetailsVisibility: function(visible) {
            simpleAjaxRequest('SetSearchDetailsVisibility', { visible: visible });
        },

        SetSearchTypeState: function(state) {
            simpleAjaxRequest('SetSearchType', { searchType: state });
        },
        
        SetFilterTypeState: function (state) {
            simpleAjaxRequest('SetFilterType', { filterType: state });
        },
        
        SetFontSizeState: function (state) {
            simpleAjaxRequest('SetFontSize', { size: state });
        },
    }
})();

